import { createFileRoute } from "@tanstack/react-router";

import { CoachedTrainingPage } from "@/features/coached-trainings/modules/coached-training/coached-training";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/booking/trainings/$trainingId")({
  loader: () => ({ crumb: m.coached_training_crumb() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { trainingId } = Route.useParams();
  return <CoachedTrainingPage trainingId={trainingId} />;
}
